import "./InputTextarea.scss";

interface InputTextareaProps {
  label: string;
  value: string;
  invalidMsg?: string;
  onChange: (value: string) => void;
  darkMode: boolean;
}

const InputTextarea = (props: InputTextareaProps) => {
  return (
    <div className={"input-textarea-wrapper" + (props.darkMode ? " dark" : "")}>
      <label className="input-label">{props.label}</label>
      <textarea
        className="input-text"
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        maxLength={500}
      ></textarea>
      <div className="remaining-chars">{props.value.length}/500</div>
      {props.invalidMsg && (
        <div className="invalid-msg">{props.invalidMsg}</div>
      )}
    </div>
  );
};

export default InputTextarea;
